import isValid from '../node_modules/date-fns/esm/isValid/index.js';
import parseISO from '../node_modules/date-fns/esm/parseISO/index.js';

/**
 * @func isISODate
 * @param {string} value - the input of the function.
 * @return {boolean}
 * @desc Checks that the input is an ISO string.
 * ```js
 * const iso = '2019-05-23T04:00:00.000Z'
 * isISODate(iso);
 * // returns true
 * ```
 * @memberof module:TypeCheck
 * @instance
 */
function isISODate(value) {
    return typeof value === 'string' && isValid(parseISO(value));
}

export { isISODate as default };
